import {
  SharedModule,
  FormInputComponent,
  InputComponentConfig,
  DataService,
  CurrencyCode,
} from "@bb-vendure/admin-ui/core";
import { Component, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";

@Component({
  selector: "currency-selector",
  standalone: true,
  imports: [SharedModule],
  templateUrl: "selector.component.html",
})
export default class CurrencySelector implements FormInputComponent, OnDestroy {
  isListInput?: boolean | undefined;
  readonly: boolean;
  formControl: FormControl<any>;
  config: InputComponentConfig;

  currencyCodes = Object.values(CurrencyCode);
  private subscription: Subscription;
  private locale: string;

  searchCurrencyCodes = (term: string, item: CurrencyCode) => {
    const currencyCodeName = new Intl.DisplayNames([this.locale], {
      type: "currency",
    }).of(item);
    return currencyCodeName?.toLowerCase().includes(term.toLowerCase());
  };

  constructor(
    dataService?: DataService,
    changeDetectorRef?: ChangeDetectorRef
  ) {
    if (dataService && changeDetectorRef) {
      this.subscription = dataService.client
        .uiState()
        .mapStream((data) => data.uiState)
        .subscribe(({ language, locale }) => {
          this.locale = language.replace(/_/g, "-");
          if (locale) {
            this.locale += `-${locale}`;
          }
          changeDetectorRef.markForCheck();
        });
    }
  }

  onChangeFn(value: any): void {
    this.formControl.patchValue(value)
    this.formControl.markAsDirty()
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
